import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import FilterHeading from './FilterHeading';
import Checkbox from '../Checkbox';
import FilterOverlay from './FilterOverlay';
import breakpoints from '../Theme/breakpoints';

const FilterSet = styled.div<{ loadingProp?: boolean }>`
  margin: 0 0 20px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  filter: blur(${({ loadingProp }) => (loadingProp ? '2px' : '0px')});

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 32px;
  }
`;

const CheckboxWrapper = styled.div`
  flex: 1 0 47%;

  .MuiFormControlLabel-root {
    margin-right: 0;
  }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    display: inline-block;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 108px;
    color: ${({ theme }) => theme.colors.blackMedium};
    letter-spacing: unset;
    margin: 2px 0 0px;
    font-size: 0.75rem;
    font-weight: bold;
  }

  .MuiButtonBase-root {
    padding: 3px;
    margin: 0 0 0 5px;
  }
`;

const FilterCheckbox = styled(Checkbox)`
  margin: 0;
  display: inline-block;
  &:before {
    content: none;
  }
`;

const additiveFilterPropertyTypes = {
  title: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired).isRequired,
  selected: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  children: PropTypes.node,
};

type AdditiveFilterProperties = Omit<InferProps<
  typeof additiveFilterPropertyTypes
>, 'choices'> & {
  loading?: boolean;
  choices: {
    name: string;
    onChange?: () => void;
    id?: number | string;
  }[];
};

const AdditiveFilter = ({
  title,
  choices,
  selected,
  loading = false,
  children,
}: AdditiveFilterProperties) => (
  <FilterSet className="product-filter" loadingProp={loading}>
    { loading && <FilterOverlay /> }
    <FilterHeading tag="h2" modal>
      {title}
    </FilterHeading>
    {choices.map((choice) => {
      const { id, name, onChange } = choice;

      return (
        <CheckboxWrapper key={id}>
          <FilterCheckbox
            label={name}
            checked={selected.includes(id)}
            onChange={onChange}
            ControlLabel={StyledFormControlLabel}
          />
        </CheckboxWrapper>
      );
    })}
    { children }
  </FilterSet>
);

AdditiveFilter.propTypes = additiveFilterPropertyTypes;

export default AdditiveFilter;
